import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
var PlLayoutAction = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, _b = _a.roundedBtn, roundedBtn = _b === void 0 ? true : _b;
    return icon ? (_jsx("button", { onClick: onClick, className: "h-8 w-8 flex items-center justify-center ".concat(roundedBtn ? 'rounded-full bg-grey-extra-light' : ''), children: icon })) : (_jsx(_Fragment, {}));
};
export default PlLayoutAction;
